"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Text = _interopRequireDefault(require("../../Text"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MobileStep = ({
  steps,
  selected
}) => {
  const progressPercentage = selected / steps.length * 100;
  const currentStep = steps.find(step => step.nr === selected);
  const isLastStep = selected === steps.length;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProgressCircle, {
      $progress: progressPercentage,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
        size: "14px",
        semibold: true,
        children: [selected, " av ", steps.length]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StepInformation, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        size: "16px",
        bold: true,
        children: currentStep?.title || ''
      }), !isLastStep && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
        size: "13px",
        semibold: true,
        subtle: true,
        children: ["Neste: ", steps[selected]?.title || '']
      })]
    })]
  });
};
var _default = exports.default = MobileStep;